import { Component, Input } from '@angular/core';
import { faClock } from '@fortawesome/free-regular-svg-icons';
import { faArrowRight, faCheck, faXmark } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-status-indicator',
  templateUrl: './status-indicator.component.html',
  styleUrls: ['./status-indicator.component.scss'],
})
export class StatusIndicatorComponent {
  faCheck = faCheck;
  faClock = faClock;
  faXmark = faXmark;
  faArrowRight = faArrowRight;

  @Input() status: any;

  dotStatus(status: any[]) {
    let dotStatusReturn = 'other';
    if (
      status[status.length - 1]?.status === 'delivered' ||
      status[status.length - 1]?.status === 'success'
    )
      dotStatusReturn = 'delivered';
    for (const dsr of status) {
      if (dsr.status === 'withdraw') {
        dotStatusReturn = 'withdrawn';
        break;
      }
      if (dsr.status === 'rejected') {
        dotStatusReturn = 'rejected';
        break;
      }
      if (dsr.status === 'timeout') {
        dotStatusReturn = 'timeout';
        break;
      }
    }
    return dotStatusReturn;
  }
}
